<template>
  <router-view />
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  methods: {
    isActive(path) {
      return this.$route.path === path
    }
  }
}
</script>

<style>
</style>
